import { render, staticRenderFns } from "./ManualsTab.vue?vue&type=template&id=d2df6728&scoped=true"
import script from "./ManualsTab.vue?vue&type=script&lang=js"
export * from "./ManualsTab.vue?vue&type=script&lang=js"
import style0 from "./ManualsTab.vue?vue&type=style&index=0&id=d2df6728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2df6728",
  null
  
)

export default component.exports